import { searchInvoices } from './customerInvoiceService'
import { errorMessages } from '@/util/helpers'

const state = {
  customerHausefulInvoices: [],
  customerHostInvoices: [],
}

const getters = {
  customerHostInvoices: (state) => state.customerHostInvoices,
  customerHausefulInvoices: (state) => state.customerHausefulInvoices,
}

const actions = {

  async fetchCustomerInvoices({ commit, dispatch, rootState }, sender) {
    try {
      commit('setIsLoading', true)

      const params = { ...rootState.filters.filters, sender }

      const { data } = await searchInvoices(params)
      const { result, total } = await data

      if (sender === 'HOST') {
        commit('setCustomerHostInvoices', result)
      } else {
        commit('setCustomerHausefulInvoices', result)
      }
      commit('setTotalPages', total)
    } catch ({ data }) {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', errorMessages(data.errors))
          : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  }
}

const mutations = {
  setCustomerHostInvoices(state, customerHostInvoices) {
    state.customerHostInvoices = customerHostInvoices
  },

  setCustomerHausefulInvoices(state, customerHausefulInvoices) {
    state.customerHausefulInvoices = customerHausefulInvoices
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
